export default __webpack_public_path__ + "static/newLogoBlue-c95a0f69498774aa6335e16e6b9477bf.png";